// Import JS Modules
import UrlBuilder from '../../_utils/url-building';
import { usePrismItemStore } from 'stores/usePrismItemStore';

const Utils = {
  dataURL(item, all = true) {
    const params = {
      _: (new Date()).getTime(),
      all: all ? 1 : undefined,
    };

    return `/m/d/${item.id}?${UrlBuilder.buildURLQuery(params)}`;
  },
  pageURL(item, index) {
    const params = {
      _: (new Date()).getTime(),
    };

    return `/m/p/${item.id}/${index}?${UrlBuilder.buildURLQuery(params)}`;
  },
  load() {
    $.mobile.loading('show', {
      text: 'Loading settings',
      textVisible: true,
      theme: 'c',
    });
    usePrismItemStore.getState().prismItem.loadActive = true;
  },
  mightHavePreview3D() {
    return (
      usePrismItemStore.getState().prismItem &&
      usePrismItemStore.getState().prismItem.pageCount === 1 &&
      (wkData && wkData.three_dimensional_view.preview3d_available)
    );
  },
};

export default Utils;
